import { render } from "./TransactionDetailsDialog.vue?vue&type=template&id=be83b2b4&ts=true"
import script from "./TransactionDetailsDialog.vue?vue&type=script&lang=ts"
export * from "./TransactionDetailsDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__